export default __webpack_public_path__ + "static/KeywordResearch_02_03-cee0db310b5e2099cea0402a4ddc1dcf.webp";